export const directions = {
  column: 'column',
  row: 'row'
}

export const FILTERS_PLACES = {
  LITE: 'lite',
  MODAL: 'modal',
  SIDEBAR: 'sidebar',
  TOPBAR: 'topbar'
}
